__webpack_require__.p = "/interactive-rating-component/";